import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetModelo145ByID = {
  status: number | null;
  statusText: string | null;
};

const useGetModelo145ByID = () => {
  const [loadingGetModelo145ByID, setLoadingGetModelo145ByID] = useState(false);
  const [successGetModelo145ByID, setSuccessGetModelo145ByID] = useState(false);
  const [errorGetModelo145ByID, setErrorGetModelo145ByID] = useState<any>(null);
  const [dataGetModelo145ByID, setDataModelo145] = useState<any>(null);

  const [statusGetModelo145ByID, setStatusGetModelo145ByID] =
    useState<StatusGetModelo145ByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getModelo145ByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetModelo145ByID(true);
    setSuccessGetModelo145ByID(false);
    setErrorGetModelo145ByID(null);

    try {
      const res = await apiRecord.getModelo145ItByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetModelo145ByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetModelo145ByID(true);
      setDataModelo145(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetModelo145ByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetModelo145ByID(err);
      console.error("Error en getModelo145ByID:", err);

      throw err;

    } finally {
      setLoadingGetModelo145ByID(false);
    }
  };

  return {
    getModelo145ByID,
    loadingGetModelo145ByID,
    successGetModelo145ByID,
    errorGetModelo145ByID,
    dataGetModelo145ByID,
    statusGetModelo145ByID
  };
};

export default useGetModelo145ByID;
